export default __webpack_public_path__ + "static/media/closeIcon.14cc98da.svg";